import { render, staticRenderFns } from "./BestPerformerCard.vue?vue&type=template&id=1fecb00a&scoped=true&"
import script from "./BestPerformerCard.vue?vue&type=script&lang=js&"
export * from "./BestPerformerCard.vue?vue&type=script&lang=js&"
import style0 from "./BestPerformerCard.vue?vue&type=style&index=0&id=1fecb00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fecb00a",
  null
  
)

export default component.exports